import { render, staticRenderFns } from "./TeacherLectureList.vue?vue&type=template&id=31b255b2&"
import script from "./TeacherLectureList.vue?vue&type=script&lang=js&"
export * from "./TeacherLectureList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports